module.exports = __webpack_public_path__ + "img/c2-3_m.210648f8.png";